import { casaBool, casaID, casaIgual, casaTexto } from "@/lib/filtros/texto";
import type { Procedimiento } from "@/lib/procedimientos";

/** CLAVES_PROCEDIMIENTOS son los parámetros que admite el listado de procedimientos (#247). */
export const CLAVES_PROCEDIMIENTOS = ["equipo", "activo", "version", "q"] as const;

/** FiltrosProcedimientos es el objeto de filtros del listado tal como viaja en la URL. */
export type FiltrosProcedimientos = Partial<Record<(typeof CLAVES_PROCEDIMIENTOS)[number], string>>;

/**
 * filtrarProcedimientos aplica los filtros en el navegador (modo sin red, D2). Debe dar el
 * MISMO resultado que el SQL del servidor: ver la tabla de casos compartida en
 * backend/internal/factory/filtros_integration_test.go (TestFiltrosProcedimientosHTTP).
 */
export function filtrarProcedimientos(
  filas: Procedimiento[],
  filtros: FiltrosProcedimientos,
): Procedimiento[] {
  return filas.filter(
    (p) =>
      casaID(filtros.equipo, p.id_equipo) &&
      casaBool(filtros.activo, p.activo) &&
      // version_procedimiento es la revisión DOCUMENTAL (texto): cotejo exacto.
      casaIgual(filtros.version, p.version_procedimiento) &&
      // La entidad no tiene columna de nombre/título: `q` solo busca en el código.
      casaTexto(filtros.q, p.codigo_procedimiento),
  );
}
